/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Button, ButtonProps } from '@material-ui/core';
import blobToBase64 from '@utils/convertBlobToBase64';

interface UploadButtonProps {
  buttonTitle: string;
  id: string;
  inputProps?: Omit<
    React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    'onChange' | 'file' | 'multiple' | 'accept' | 'id' | 'style'
  >;
  onChange: (fileURL: string) => void;
  buttonProps?: Omit<ButtonProps<'label'>, 'children' | 'component' | 'htmlFor'>;
}
const UploadButton = ({
  buttonTitle,
  id,
  inputProps,
  onChange,
  buttonProps,
}: UploadButtonProps) => (
  <>
    <Button variant='contained' color='primary' component='label' htmlFor={id} {...buttonProps}>
      {buttonTitle}
    </Button>
    <input
      type='file'
      accept='image/png,image/jpeg,image/bmp,image/jpg,image/tiff,image/gif'
      id={id}
      style={{
        width: 0,
        height: 0,
      }}
      onChange={async ({ target: { files } }) => {
        if (files?.length) {
          const base64 = await blobToBase64(files[0]);
          onChange(base64);
        }
      }}
      {...inputProps}
    />
  </>
);

export default UploadButton;



// WEBPACK FOOTER //
// ./src/screens/review-section2/document-upload/v2/UploadButton.tsx